import { HTMLAttributes } from "react";
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} rev={undefined} spin />;

export interface TotalCounterItemProps extends HTMLAttributes<HTMLDivElement> {
    active: boolean;
    isLoading: boolean;
    isError: boolean;
    label: string;
    number?: number;
}

const TotalCounterItem = (props: TotalCounterItemProps) => {
    const { active, isLoading, isError, label, number, ...rest } = props;
    return (
        <div
            {...rest}
            className={`card-counter${active ? ' active' : ""}`}
        ><div className="caption-text count">
                {isLoading ? (
                    <Spin indicator={antIcon} />
                ) : isError ? "" : number?.toLocaleString().toString().replace(/,/g, ' ')}
            </div>
            <div className="label">{label}</div>
        </div>
    )
}

export default TotalCounterItem;